<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-card>
      <v-toolbar color="primary" dark flat short class="px-2">
        <v-toolbar-title>Decoration</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="cancel()" icon><v-icon>fas fa-times</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="mt-12">
        <v-form @submit.prevent>

            <v-text-field
              outlined
              class="mb-2"
              v-model="model.description"
              :error-messages="errors.description"
              label="Description"
            ></v-text-field>

            <v-text-field
              outlined
              class="mb-2"
              v-model="model.slug"
              :error-messages="errors.slug"
              label="Slug"
            ></v-text-field>

            <v-alert
              v-if="error"
              type="error"
              dense
              outlined
            >
              {{ error }}
            </v-alert>            
          

        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 pb-8">
        <v-btn
          v-if="model.id"
          color="error"
          class=""
          large
          outlined
          depressed
          :disabled="!user.can('preset.delete')"
          @click="$refs.deleteItemConfirmDialog.show()"
        >Delete</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="px-5"
          large
          outlined
          depressed
          @click="cancel()"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          class="px-5"
          large
          depressed
          @click="save()"
        >Save</v-btn>
      </v-card-actions>

      <ConfirmDialog
        ref="deleteItemConfirmDialog"
        @confirm="deleteItem()"
        title="Confirm"
        message="Decoration will be deleted. Are you sure?"
        labelConfirm="OK"
        labelCancel="Cancel"
      ></ConfirmDialog>


    </v-card>

  </v-dialog>
</template>

<script>
import { ref, watch, inject } from 'vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    value: Boolean,
    model: Object,
    errors: Object,
    error: String,
    techniques: Array,
  },
  setup(props, context) {
    const api = inject('api')
    const { user } = api
    const dialog = ref(false)

    watch(() => props.value, val => {
      dialog.value = val
    })

    watch(dialog, val => {
      context.emit('input', val)
    })

    function save() {
      context.emit('save')
    }

    function cancel() {
      dialog.value = false
      context.emit('cancel')
    }

    function show() {
      dialog.value = true
    }

    function hide() {
      dialog.value = false
    }

    function deleteItem() {
      context.emit('delete', props.model)
    }

    return {
      user,
      dialog,

      save,
      cancel,

      show,
      hide,
      deleteItem,
    }
  }}
</script>